























import { Component, Vue, Prop } from 'vue-property-decorator'
import Event from '@/models/event'
import axios from '@/server-axios'
import { Actions } from '@/util/vuex-types'
import { Action } from 'vuex-class'

@Component
export default class RateBreweryForm extends Vue {

    @Prop(Object) event!: Event
    beer: number = 0
    experience: number = 0
    submitting = false
    @Action [Actions.FETCH_EVENTS]: any

    async submitRating() {
        try {
            this.submitting = true
            const request = {
                code: this.event.code,
                rating: {
                    beer: this.beer,
                    experience: this.experience,
                },
            }
            const { status } = await axios.post('ratings/' + this.event.id, request, {
                headers: {
                    Authorization: 'Bearer ' + await this.$auth.getAccessToken(),
                },
            })

            if (status === 201) {
                await this.fetchEvents(await this.$auth.getAccessToken())
                this.$emit('rated')
            }
        } catch (e) {
            console.warn(e)
        }
    }
}
